import { MutationTree } from 'vuex'
import { FromAddressesStateInterface } from '@/models/store/FromAddressesState.interface'
import { FromAddressInterface } from '@/models/FromAddress.interface'

const mutations: MutationTree<FromAddressesStateInterface> = {
  loading(state: FromAddressesStateInterface) {
    state.loading = true
  },
  loaded(state: FromAddressesStateInterface) {
    state.loading = false
  },
  saving(state: FromAddressesStateInterface) {
    state.saving = true
  },
  saved(state: FromAddressesStateInterface) {
    state.saving = false
  },
  updateFromAddresses(
    state: FromAddressesStateInterface,
    fromAddresses: FromAddressInterface[]
  ) {
    state.fromAddresses = fromAddresses
  }
}

export default mutations
